import {Model} from './Model';

export class InfoButtonText extends Model {
  public title: string = '';
  public text: string = '';
  public translations: { [key: string]: any } | null = null;

  constructor(data: any) {
    super(data);
    this.title = data.title;
    this.text = data.text;
    this.translations = data.translations;
  }

  toString(): string {
    return this.text;
  }
}
